import styled from "styled-components";

export const ScreenArea = styled.div`
    width: 100vw;
    height: 100vh;

    /* display: ${props => props.isOpen ? 'block' : 'none'}; */
    display: block;
    position: fixed;

    top: 0;
    left: 0;
    z-index: 949;
    background-color: rgba(0,0,0,0.2);
`;

export const Container = styled.div`

    right: ${props => props.isOpen ? '0%' : '-100%'};


    @keyframes open {
        0% {
            right: -100%;
        }
        100% {
            right: 0%;
        }
    }

    @keyframes close {
        0% {
            right: ${props => props.animation ? '0%' : '-100%'};
        }
        100% {
            right: -100%;
        }
    }

    position: fixed;
    top: 0px;

    width: 45%;
    height: 100vh;
    max-width: 550px;
    padding: 36px;

    
    animation-name: ${props => props.isOpen ? 'open' : 'close'};
    animation-duration: 1s;

    background-color: #FFF;
    border: 1px solid #FFF;

    border-top-left-radius: 20px;
    border-bottom-left-radius: 20px;

    box-shadow: 0px 2px 5px 1px rgba(29, 33, 41, 0.4);

    z-index: 950;
    overflow: auto;


      /* width */
    ::-webkit-scrollbar {
        width: 6px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
        background: transparent; 
    }
    
    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: #888; 
        border-radius: 8px;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
        background: #555; 
    }
    

    @media only screen and (max-width: 768px) {
        top: auto;
        bottom: 0;
        min-width: 100%;
        max-height: 90%;
        padding-bottom: 120px;

        border-top-left-radius: 1.25rem;
        border-top-right-radius: 1.25rem;
        border-bottom-left-radius: 0;
    
        @keyframes open {
        0% {
            bottom: -100%;
        }
        100% {
            bottom: 0%;
        }
    }

    @keyframes close {
        0% {
            bottom: ${props => props.animation ? '0%' : '-100%'};
        }
        100% {
            bottom: -100%;
        }
    }
    }

`;

export const HeaderArea = styled.div`
    width: 100%;
    height: 50px;
    max-width: 550px;
    padding-left: 0px;
    /* padding-right: 50px; */
    
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    
    background-color: #FFF;
    /* position: fixed; */
    /* z-index: 500; */

    @media only screen and (max-width: 768px) {
        min-width: 75%;
    }
`;

export const Title = styled.div`
    width: auto;
    height: auto;
`;

export const Fundo = styled.div`
    position: fixed;
    top: 0;
    left: 0;

    width: 100vw;
    height: 100vh;

    background-color: #000;
    opacity: 0.5;
    z-index: 949;
`;

export const Close = styled.div`
    width: 36px;
    height: 36px;
    padding: 4px;
    
    display: flex;
    align-items: center;
    justify-content: center;

    cursor: pointer;
    border-radius: 90%;
    background-color: #E8EAED;
    /* margin-right: 15px; */
    /* margin-left: -5px; */

    @media only screen and (max-width: 768px) {
        width: 38px;
    }
`;

export const ContainerButtons = styled.div`
    width: auto;
    height: auto;

    gap: 24px;
    display: flex;
    align-items: center;
`;